import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type EntregaData = {
	id_entrega: number;
	id_loja: number;
	id_venda: number;
	id_entregador: number;
	nome_entregador: string;
	nome_cliente: string;
	tipo_venda: string;
	data_venda: string;
	data_entrega: string;
	data_previsao: string;
	atraso: string;
	tempo: string;
	obs_entrega: string;
	pago: string;
	evento: string;
	motivo: string;
	vlr_custo: number;
	vlr_entrega: number;
	vlr_troco: number;
	vlr_total: number;
	vlr_custoFormatted: string;
	vlr_entregaFormatted: string;
	vlr_trocoFormatted: string;
	vlr_totalFormatted: string;
};
interface DataTableSearchParams {
  entregas: EntregaData[];
  setPesqEntregas: (entregas: EntregaData[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
    produtos: EntregaData[],
  ) => void;
}

const DataTableSearch: React.FC<DataTableSearchParams> = ({
  entregas,
  setPesqEntregas,
  controls,
  setControls,
  handleUpdateList,
}) => {
  function handlePesquisa(event: string) {
    const texto = event;

    if (texto === '' || texto === ' ') {
			setPesqEntregas(entregas);

      setControls({
        ...controls,
        page: 1,
				totalPage: Math.ceil(entregas.length / controls.perPage),
      });
			handleUpdateList(1, controls.perPage, entregas);
      return;
    }

		const searchKeys = [
			'id_venda',
			'id_entrega',
			'nome_entregador',
			'nome_cliente',
			'vlr_custo',
			'vlr_troco',
			'vlr_entrega',
			'tipo_venda',];
		const results = search(entregas, searchKeys, texto) as EntregaData[];

		setPesqEntregas(results);
    setControls({
      ...controls,
      page: 1,
      totalPage: Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList(1, controls.perPage, results);
  }

  return (
		<Flex as="form" ml={["0", "0", "4"]}>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
          onChange={e => handlePesquisa(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DataTableSearch;
